import {styledByTheme} from "../../../themes/architecture/styled-by-theme";
import {MainWrapperDefaultBox} from "./main-wrapper.default.box";
import {MainWrapperCasino777Box} from "./main-wrapper.casino777.box";
import { MainWrapperCasino888Box } from "./main-wrapper.casino888.box";
import { MainWrapperCipBox } from "./main-wrapper.cip.box";
import { MainWrapperHarrahsBox } from "./main-wrapper.harrahs.box";
import { MainWrapperWsopBox } from "./main-wrapper.wsop.box";

export const MainWrapperBox = styledByTheme(MainWrapperDefaultBox)
    .forCasino888(MainWrapperCasino888Box)
    .forCasino777(MainWrapperCasino777Box)
    .forCip(MainWrapperCipBox)
    .forHarrahs(MainWrapperHarrahsBox)
    .forWsop(MainWrapperWsopBox)
    .apply();
